<template>
    <Suits url="adminsuit"/>
</template>

<script>
import Suits from './Suits.vue';
export default {
    name:"adminSuits",
    components:{
        Suits
    }
}
</script>